"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalStyle = exports.bodyStyles = exports.fontUrl = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = require("styled-components");

var _templateObject;

var fontUrl = 'https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap';
exports.fontUrl = fontUrl;
var bodyStyles = (0, _styledComponents.css)(["@font-face{font-family:'Poppins';src:url(", ");}font-family:'Poppins',sans-serif;"], fontUrl);
exports.bodyStyles = bodyStyles;
var GlobalStyle = (0, _styledComponents.createGlobalStyle)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n body {\n   ", "\n }\n"])), bodyStyles);
exports.GlobalStyle = GlobalStyle;